import React from "react";
import { useNavigate } from "react-router-dom";
import {
  removeExpandedItemByDepth,
  selectExpandedItemsByDepth,
  setExpandedItemByDepth,
  setMobileSidebarOpen,
  setSelectedTreeItemByResourceId,
} from "../../../../layoutSlice";
import { useAppDispatch, useAppSelector } from "../../../../../../hooks/storeHooks";

export const useTreeView = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const expandedItemsByDepth = useAppSelector(selectExpandedItemsByDepth);

  const handleItemClick = (event: React.MouseEvent<HTMLLIElement>, path: string, itemId: string) => {
    event.stopPropagation();
    navigate(path);
    dispatch(setSelectedTreeItemByResourceId(itemId));
    dispatch(setMobileSidebarOpen(false));
  };

  const handleIconClick = React.useCallback(
    (event: React.MouseEvent<HTMLDivElement>, path: string, itemId: string, name: string, depth: number) => {
      event.stopPropagation();
      navigate(path);
      if (expandedItemsByDepth[depth] === itemId) {
        dispatch(removeExpandedItemByDepth(depth));
      } else {
        dispatch(setExpandedItemByDepth({ depth, itemId }));
      }
      dispatch(setSelectedTreeItemByResourceId(itemId));
    },
    [dispatch, expandedItemsByDepth, navigate],
  );

  return {
    expandedItemsByDepth,
    handleItemClick,
    handleIconClick,
  };
};
